import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Outdent = createReactComponent("Outdent", ["svg", defaultAttributes, [["polyline", {
  points: "7 8 3 12 7 16",
  key: "19cpua"
}], ["line", {
  x1: "21",
  y1: "12",
  x2: "11",
  y2: "12",
  key: "1sr45m"
}], ["line", {
  x1: "21",
  y1: "6",
  x2: "11",
  y2: "6",
  key: "1w72kw"
}], ["line", {
  x1: "21",
  y1: "18",
  x2: "11",
  y2: "18",
  key: "108ogh"
}]]]);
export default Outdent;